import React from "react";

function BlogPostSkeleton() {
  return (
    <div className="bg-white animate-pulse">
      <div className="container text-center mx-auto py-12 px-4 lg:px-0">
        <div className="h-4 bg-slate-200 rounded w-32 mx-auto mb-10" />
        <div className="h-8 bg-slate-200 rounded w-2/3 mx-auto mb-10" />
        <div className="hidden md:flex justify-center items-center border-y py-5 mb-10 max-w-3xl mx-auto space-x-4">
          {Array.from({ length: 4 }).map((_, idx) => (
            <div key={idx} className="h-4 bg-slate-200 rounded w-24" />
          ))}
        </div>
      </div>
      <div className="h-64 bg-slate-200 md:max-w-6xl mx-auto rounded mb-8" />
      <div className="flex justify-center my-20">
        <div className="h-6 bg-slate-200 rounded w-2/3" />
      </div>
      <div className="max-w-3xl mx-auto px-4 lg:px-0 space-y-4">
        {Array.from({ length: 6 }).map((_, idx) => (
          <div key={idx} className="h-4 bg-slate-200 rounded" />
        ))}
      </div>
      <div className="flex max-w-3xl mx-auto space-x-2 my-10">
        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="h-6 bg-slate-200 rounded-full w-20" />
        ))}
      </div>
    </div>
  );
}

export default BlogPostSkeleton;